import React from "react";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import moment from 'moment';

const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class Logs extends React.Component {
  
   constructor(props) {
    super(props);
    this.state = {
      logs: this.props.logs,
    }
  }
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs});
  }
  
  formatDate(date) {
    var options = {
      month: 'short', day: '2-digit', hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);

    return formattedDate;
  }
  
  fightTime(hookeduptime, catchDate) {
    if(hookeduptime && catchDate) {
      var time = (new Date(catchDate) - new Date(hookeduptime));
      var minutes = parseInt(((time / (1000 * 60)) % 60), 10);
      var hours = parseInt(((time / (1000 * 60 * 60)) % 24), 10);
      var h = (hours < 10) ? "0" + hours : hours;
      var m = (minutes < 10) ? "0" + minutes : minutes;
      if(parseInt(h, 10) !== parseInt(0, 10)){
      return h + "Hrs " + m + "Mins";
    } else {
      return Math.abs(minutes) + " min. fight";
    }
    }
      return null;
  }
  
  elapsedTime(hookeduptime) {
    var time = new Date() - new Date(hookeduptime);
    
    var minutes = parseInt(((time / (1000 * 60)) % 60), 10);
    var hours = parseInt(((time / (1000 * 60 * 60)) % 24), 10);
    var h = (hours < 10) ? "0" + hours : hours;
    var m = (minutes < 10) ? "0" + minutes : minutes;
    if(parseInt(h, 10) !== parseInt(0, 10)){
      return h + "Hrs " + m + "Mins";
    } else {
      return minutes + " Mins";
    }
  }
  
  render() {
    return (
      <div className="logs-container">
          {this.props.logs.length > 0 ? this.props.logs.map(log => (
            <div id='log-box' className="pesc_logCell2" style={{flex: 1, padding: 1}} key={log.id}>
              <div className="log-row2">
                <div className="pesc_logName2">{moment(log.catchDate).format('h:mm a Do')}</div>
                <div className="pesc_logName2">{log.boatName}</div>
                <div className="pesc_logName2">{log.anglerName}</div>
                <div className="pesc_logName2">{log.speciesName}</div>
              </div>
            </div>
          )) : null}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pescadora/comps/Logs.js